import { type MutableDatabase } from '@databases/model/database';

import { CanvasTransactionOrigin } from '@canvas/transaction';

/**
 * Wraps the browser AIFC database so agent-authored mutations are recorded with
 * an agent Yjs transaction origin. The first-edit analytics listener reads that
 * transaction origin to set `isAIGenerated`, while explicit origins remain
 * untouched for any caller that needs to override the default.
 */
export const withAgentMutationOrigin = (database: MutableDatabase): MutableDatabase =>
  new Proxy(database, {
    get(target, property) {
      if (property === 'mutate') {
        return (
          update: (database: MutableDatabase) => void,
          origin: CanvasTransactionOrigin | undefined = CanvasTransactionOrigin.Agent
        ) => target.mutate(update, origin);
      }

      const value = Reflect.get(target, property, target);

      return typeof value === 'function' ? value.bind(target) : value;
    },
  });
